import { Component } from '@angular/core'

@Component({
  selector: 'lin-layout-form-toolbar',
  template: ` <ng-content></ng-content> `,
  styleUrls: ['./form-toolbar.component.scss'],
  standalone: false,
})
export class FormToolbarComponent {}
